import React from 'react';
import { menuData } from '../data/mockData';

export const PromoSection = () => {
  return (
    <section id="promos" className="py-16 bg-gradient-to-b from-black to-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            🎉 PROMOTIONS PIZZAS
          </h2>
          <p className="text-lg text-gray-400">
            Profitez de nos offres exceptionnelles !
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {menuData.pizzas.offers.sections.map((section, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-[#ECEC75] to-[#D4A85F] p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="text-5xl">{section.emoji}</span>
                <h3 className="font-bold text-black text-2xl">{section.type}</h3>
              </div>
              
              <div className="bg-white/30 p-4 rounded-xl mb-4">
                <p className="text-black font-bold text-3xl text-center">
                  {section.offer}
                </p>
              </div>

              <div className="space-y-2">
                {section.conditions.map((condition, condIdx) => (
                  <div key={condIdx} className="flex items-start gap-2">
                    <span className="text-black text-lg mt-1">👉</span>
                    <p className="text-gray-900 font-medium text-base flex-1">
                      {condition}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
